import type { SyncStatus } from "./useSync.js";

/**
 * §12 — the sync indicator.
 *
 * Rule U-1: offline is presented as normal, never as failure. The club plays
 * in a sports hall and poor signal is the expected condition, so the offline
 * state is neutral and quiet while a conflict is amber and loud.
 *
 * Rule U-2: always visible during a session, never behind navigation.
 */
export function SyncIndicator({
  status,
  onTap,
}: {
  status: SyncStatus;
  onTap?: () => void;
}): React.JSX.Element {
  const { state, counts } = status;

  const label = {
    synced: "Saved",
    pending: `${counts.pending} to sync`,
    syncing: "Syncing…",
    conflict: `${counts.conflict} need${counts.conflict === 1 ? "s" : ""} a decision`,
    failed: `${counts.failed} need${counts.failed === 1 ? "s" : ""} fixing`,
    offline: counts.pending > 0 ? `Offline · ${counts.pending} saved here` : "Offline",
  }[state];

  return (
    <button className={`sync sync-${state}`} onClick={onTap} aria-live="polite">
      <span className="sync-dot" aria-hidden="true" />
      {label}
    </button>
  );
}
